import Hamburger from "@/components/Hamburger"
import classNames from "classnames"
import React from "react"
import Typography from "../foundation/typography"
import style from "./style.scss"

interface HeaderProps {
  sidebarToggle: () => void
  title: string
}

const Header: React.SFC<Readonly<HeaderProps>> = (props) => {
  return (
    <header className={classNames(style.header)}>
      <button onClick={props.sidebarToggle}>
        <Hamburger />
      </button>

      <Typography.P2 className={style.title}>{props.title}</Typography.P2>
    </header>
  )
}

export default Header
